import { render } from "./createAllotmentComponent.vue?vue&type=template&id=62691c09&scoped=true"
import script from "./createAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./createAllotmentComponent.vue?vue&type=script&lang=js"

import "./createAllotmentComponent.vue?vue&type=style&index=0&id=62691c09&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62691c09"]])

export default __exports__